import {inject, Injectable} from '@angular/core';
import {createPublicClient, defineChain, http, PublicClient, webSocket} from 'viem';
import {hardhat} from 'viem/chains';
import {AppConfigService} from '../../services/config.service';

@Injectable({providedIn: 'root'})
export class CommonBlockchainUtilService {

    private publicClient: PublicClient;

    private readonly appConfigService = inject(AppConfigService);

    public isHardhat(): boolean {
        return this.appConfigService.appConfig.dex.chain.id === hardhat.id;
    }

    public getPublicClient(): PublicClient {
        this.publicClient ??= this.createPublicClient();

        return this.publicClient;
    }

    private createPublicClient(): PublicClient {
        const chainConfig = this.appConfigService.appConfig.dex.chain;
        const chain = defineChain(chainConfig);

        const transport = chainConfig.rpcUrls.default.webSocket
            ? webSocket()
            : http();

        return createPublicClient({
            chain,
            transport
        }) as any; // A workaround for strange type errors
    }

}
